<template>
  <div class="wrapper">
      <div class="card-custom">
      </div>
  </div>
</template>

<script>
export default {
    name: 'card'
}
</script>

<style>
.card-custom{
  border: 1px solid #fff;
  border-radius: 15px;
  /* box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2); */
  font-size: 2rem;
  height: 220px;
  overflow: hidden;
  position: relative;
  width: 370px;
}

.card-custom:before {
  background-color: rgba(255, 255, 255, 0.3);
  /* backdrop-filter: blur(10px) saturate(100%) contrast(45%) brightness(130%); */
  content: '';
  height: 100%;
  position: absolute;
  width: 100%;
}
</style>